// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1g8Rc","text":"SelectPayment_text__2WCOG","title":"SelectPayment_title__3r6vE","btn":"SelectPayment_btn__28eZV"};